import { colors } from './colors';

export const tag = {
  success: {
    background: colors.greenLight,
  },
  error: {
    background: 'rgba(252, 61, 35, 0.2)',
  },
  warn: {
    background: '#FFE0C6',
  },
  inactive: {
    background: '#E5E5E5',
  },
  blue: {
    background: 'rgba(32, 139, 206, 0.2)',
  },
};
